import React from 'react';
import { Button } from '@lt/components';
import PropTypes from 'prop-types';

import { i18n } from '@lt/localization';
import TouristField from '../TouristField';
import { GENDER } from '../../../routes/Checkout/store/constants/tourists';
import Icon from '../../Icon';

export default class TouristGender extends React.PureComponent {
  static ICONS = {
    [GENDER.MALE]: {
      name: 'gender-male',
      color: '#4a90e2',
    },
    [GENDER.FEMALE]: {
      name: 'gender-female',
      color: '#e568b2',
    },
    NONE: {
      name: 'gender-unidentified',
      color: '#c2c5cc',
    },
  };

  constructor(props) {
    super(props);
    this.toggleGender = this.toggleGender.bind(this);
  }

  toggleGender() {
    const { value, onChange } = this.props;
    onChange(value === GENDER.MALE ? GENDER.FEMALE : GENDER.MALE);
  }

  render() {
    const { value } = this.props;
    const icon = TouristGender.ICONS[value] || TouristGender.ICONS.NONE;
    return (
      <TouristField
        {...this.props}
        label={i18n.t('checkout.touristForm.gender')}
        className="tourist-gender-field"
        fieldType="gender"
      >
        <Button functional onClick={this.toggleGender}>
          <Icon type={icon.name} width="11px" height="20px" />
        </Button>
      </TouristField>
    );
  }
}

TouristGender.defaultProps = {
  value: null,
};
TouristGender.propTypes = {
  value: PropTypes.oneOf(Object.values(GENDER)),
  onChange: PropTypes.func.isRequired,
};
